<template>
  <div class="navbar-background"></div>
  <nav class="navbar navbar-expand-lg color-white" aria-label="Главное меню">
    <div class="container">
      <RouterLink class="navbar-brand" to="/">
        <div class="login-box-logo d-flex align-items-center gap-2">
          <img :src="logoIMG" :alt="mainTitle" width="48" height="48" />
          
          <span class="ml-3 font-weight-bold d-none d-lg-block text-white" style="font-size: 1.25rem;">
            {{ mainTitle }}
          </span>
        </div>
      </RouterLink>

      <div class="d-flex">
        <div class="lv-header-toolbar">
          <div class="dropdown">
            <a
              class="nav-link d-none d-md-block"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ auth.userInfo?.name }}<img src="@/assets/chevron-right.svg" />
            </a>
            <a
              class="btn-lv btn-lv-light d-block d-md-none"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="8 10 12 14 16 10"></polyline>
              </svg>
            </a>
            <ul class="dropdown-menu dropdown-menu-end mt-3">
              <li>
                <RouterLink class="dropdown-item" :to="{ name: 'Profile' }"
                  >Пользователь</RouterLink
                >
              </li>
              <li>
                <RouterLink class="dropdown-item" :to="{ name: 'DicFileTemplateList' }"
                  >Шаблоны документов</RouterLink
                >
              </li>
              <li>
                <a class="dropdown-item" href="/" @click="signOutHandler">Выйти</a>
              </li>
            </ul>
          </div>
          <RouterLink :to="{ name: 'NoticeView' }">
            <span class="btn-lv-light position-relative">
              <img
                src="@/assets/bell.svg"
                :class="{ 'icon-notice-unread': auth.notice_unread > 0 }"
              />
              <span class="notification-count" v-if="auth.notice_unread > 0">{{
                auth.notice_unread
              }}</span>
            </span>
          </RouterLink>
          <div class="d-md-block" id="navbarToggleExternalContent">
            <accountSelector />
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink, useRouter } from "vue-router";
import { useAuthStore } from "@/stores/user-auth";
import accountSelector from "@/views/common/account-selector.vue";

const router = useRouter();
const auth = useAuthStore();
const mainTitle = import.meta.env.VITE_BASE_NAME;
const logoIMG = "/img/icons/logo.svg";

const signOutHandler = () => {
  auth.userLogOut();
  router.push({ name: "login" });
};
</script>
<style>
.navbar-background {
  position: absolute;
  width: 100%;
  top: 0px;
  background-image: url(@/assets/back.svg);
  background-size: cover;
  border-radius: 0px 0px 32px 32px;
  height: 174px;
}
.color-white {
  color: #ffffff;
}
.lv-header-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 40px;
}
.icon-notice {
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 48px;
  height: 48px;
  margin-right: 12px;
}
.navbar-toggler {
  border: none !important;
}
.lv-header-toolbar {
  gap: 12px;
}
.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  color: white;
  font-size: 12px;
}

@media (max-width: 768px) {
  .btn-lv-light {
    display: block;
    height: 48px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    font-size: 16px;
    line-height: 24px;
    text-decoration: none;
  }
}
</style>
